import { render, staticRenderFns } from "./RegisterConfirmingComponent.vue?vue&type=template&id=1e4022ca&"
import script from "./RegisterConfirmingComponent.vue?vue&type=script&lang=js&"
export * from "./RegisterConfirmingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports